(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gr-mini-cart-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    const drawer = button.closest('cart-drawer');
    const error = button.closest('.gr-mini-cart__upsell')?.querySelector('.gr-mini-cart__quick-error');
    button.setAttribute('aria-disabled', 'true');
    const originalLabel = button.textContent;
    button.textContent = button.dataset.loadingLabel || originalLabel;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    try {
      const body = new FormData();
      body.append('id', button.dataset.grMiniCartAdd);
      body.append('quantity', '1');
      body.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      body.append('sections_url', window.location.pathname);
      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add item.');
      drawer.renderContents(state);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gr-mini-cart', cartData: state });
      }
    } catch (exception) {
      if (error) {
        error.textContent = exception.message;
        error.hidden = false;
      }
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  });
})();
